{
    "Omclient": "Cliente omnichannel:",
    "OmclientAgentValidation": "Un cliente Omnichannel richiede un agente ACD endpoint",
    "DeviceHint": "Selezionare l'endpoint del supervisore per consentire il controllo delle chiamate basato su browser.",
    "OmnichannelAgent": "Agente omnichannel:",
    "NoneSelected": "[Nessuno selezionato]",
    "NoAssociatedDevice": "[Nessun dispositivo associato]",
    "NoAssociatedAgent": "[Nessun agente ACD associato]",
    "ExtensionEndpoint_PermissionsNote": "Impostare le autorizzazioni del livello di accesso dell'utente.",
    "ExtensionEndpoint_CmEnvironment": "ECM:",
    "ExtensionEndpoint_TelServer": "Server di telefonia:",
    "ExtensionEndpoint_Partition": "Partizione:",
    "ExtensionEndpoint_Device": "Dispositivo:",
    "ExtensionEndpoint_AndOrAgent": "E\/O Agente:",
    "NAME": "ExtensionEndpoint",
    "ExtensionEndpoint_Validation_Professional_Device": "Un utente Professional deve avere un endpoint del dispositivo impostato",
    "ExtensionEndpoint_Validation_Professional_Device_MST": "Un utente CXA non utilizzato deve avere un endpoint di dispositivo impostato",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent": "Un agente del call center deve avere un endpoint agente impostato",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent_MST": "Un utente CXA Premium deve avere un endpoint agente impostato"
}